import componentFn from '../../styles/objects/component'
import { important } from '../../styles/tools/parsers'
import breakTo from '../../styles/tools/breakTo'
export default ({
  colors,
  spacings,
  images,
  fontFamilies,
  fontWeights,
  fontSizes,
  textTransforms
}) => {
  const component = componentFn({
    colors,
    spacings,
    images,
    fontFamilies,
    fontWeights,
    fontSizes,
    textTransforms
  })

  const styles = {
    label: {
      fontFamily: fontFamilies.alternate,
      marginBottom: '0',
      ':not(:first-child)': {
        marginTop: '0'
      }
    },

    'label--small': {
      fontSize: '13px'
    },

    'label--padded': {
      marginTop: important('2rem')
    },

    'label--bold': {
      fontWeight: fontWeights.label.default
    },

    'label--centered': {
      textAlign: 'center'
    },
    'label--align':{
      verticalAlign: 'middle',
      width:'50%!important'
    },
    'widget-group__title': {
        color: colors.widget.groupTitle.default,
        [breakTo('medium')]: {
          position: 'absolute',
          marginLeft: '-16vw',
          fontWeight: fontWeights.widget.group,
          marginTop : '2.5vw',
          width: '14vw',
          textAlign: 'right'
        }
      },
  }

  return { ...component, ...styles }
}



// WEBPACK FOOTER //
// ./components/label/styles.js